import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const External: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.25 6.25h4.286v-1.5H5.964c-.67 0-1.214.544-1.214 1.214v12.072c0 .67.544 1.214 1.214 1.214h12.072c.67 0 1.214-.544 1.214-1.214v-4.572h-1.5v4.286H6.25V6.25zm10.44 0H13.5v-1.5h5.75v5.75h-1.5V7.31l-7.72 7.72-1.06-1.06 7.72-7.72z'
        fill='currentColor'
      />
    </svg>
  </i>
);

External.displayName = 'External';
export default External;
